module.exports = __webpack_public_path__ + "assets/film-8d6fd5fa7ae65f8044b8578407a98d51.svg";